import React from "react";
import { useNavigate } from "react-router-dom";
import { useViewport } from "../../common/hooks/ViewPort";
import ListRow from "src/components/atoms/ListRow/ListRow";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
const ServicePage: React.FC = () => {
  const navi = useNavigate();
  const { px } = useViewport();

  // const log = (msg: string) => () => console.log(`[Service] ${msg}`);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        maxHeight: "100vh",
        maxWidth: "45rem",
        margin: "0 auto",
        position: "relative",
        background: "#F7F7F7",
        padding: "0 16px",
        boxSizing: "border-box",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100vh",
          maxHeight: "100vh",
          position: "relative",
          background: "#F7F7F7",
          boxSizing: "border-box",
        }}
      >
        {/* 헤더 */}
        <SubConHeader title="고객센터" onClickArrow={() => navi("/myinfo")} />

        {/* 리스트 카드 */}
        <div
          style={{
            marginTop: px(12),
            background: "#FFFFFF",
            borderRadius: px(14),
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            overflow: "hidden",
          }}
        >
          <ListRow
            label="자주 묻는 질문"
            onClick={() => navi("/service/faq")}
            px={px}
            boldT={true}
          />
          {/* <div style={{ height: 1, background: "#F1F2F4" }} /> */}
          {/* <ListRow
            label="1:1 문의"
            onClick={log("탭: 1:1 문의")}
            px={px}
            boldT={true}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
